/**
 * Route for `dynamic-commission-by-sku`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { DynamicCommissionBySkuPage } from "../features/dynamic-commission-by-sku/DynamicCommissionBySkuPage";

export const dynamicCommissionBySkuRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/dynamic-commission-by-sku",
	component: DynamicCommissionBySkuPage,
});

export default dynamicCommissionBySkuRoute;
